import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

// テーブルカラムの定数
export const Columns = {
  ASSIGNED_USER: "ASSIGNED_USER",
  DEVICE_PLACEMENT: "DEVICE_PLACEMENT",
  NOTES: "NOTES",
} as const;
export type Columns = EnumUnion<typeof Columns>;

// YAGNI: 初期スコープでは未割り当てのライセンスは表示しない
export const LicensePeopleCategoryFilterKey = {
  ASSIGNED: "ASSIGNED",
} as const;
export type LicensePeopleCategoryFilterKey = EnumUnion<
  typeof LicensePeopleCategoryFilterKey
>;

export const TabKey = {
  ASSIGNED: LicensePeopleCategoryFilterKey.ASSIGNED,
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

export const TabKeySchema = z.nativeEnum(TabKey);

export const SearchSchema = z.object({
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC),
  category: z
    .nativeEnum(LicensePeopleCategoryFilterKey)
    .default(LicensePeopleCategoryFilterKey.ASSIGNED),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.enum([Columns.ASSIGNED_USER]).optional(),
});
